export const ONBOARDING_ADMINS_AUTH_SHOW = 'ONBOARDING_ADMINS_AUTH_SHOW'
export const ONBOARDING_ADMINS_AUTH_SHOW_PENDING = 'ONBOARDING_ADMINS_AUTH_SHOW_PENDING'
export const ONBOARDING_ADMINS_AUTH_SHOW_FULFILLED = 'ONBOARDING_ADMINS_AUTH_SHOW_FULFILLED'
export const ONBOARDING_ADMINS_AUTH_SHOW_REJECTED = 'ONBOARDING_ADMINS_AUTH_SHOW_REJECTED'

export const ONBOARDING_ADMINS_REGISTER_POST = 'ONBOARDING_ADMINS_REGISTER_POST'
export const ONBOARDING_ADMINS_REGISTER_POST_PENDING = 'ONBOARDING_ADMINS_REGISTER_POST_PENDING'
export const ONBOARDING_ADMINS_REGISTER_POST_FULFILLED = 'ONBOARDING_ADMINS_REGISTER_POST_FULFILLED'
export const ONBOARDING_ADMINS_REGISTER_POST_REJECTED = 'ONBOARDING_ADMINS_REGISTER_POST_REJECTED'
